import MainContainer from '../main-container';
import Form from './districtForm';
import List from './districtList';
import { paths } from '../../config';

const settings = {
    pathRegister: paths.districtRegister,
    pathList: paths.district,
    apiPath: 'district',
    permissionAdmin: null,
    title: 'Bairro',
};

const District: React.FC = () => {
    return (
        <MainContainer>
            <Form settings={settings} />
        </MainContainer>
    );
};

const DistrictList: React.FC = () => {
    return (
        <MainContainer>
            <List />
        </MainContainer>
    );
};

export { District, DistrictList };
